import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { selectors as authSelectors } from '@hixme/auth-ui'
import { clientsAllowedByCensusV2Flag } from '../utils/clients-allowed-by-census-v2-flag'
import { SimpleCustomerDto } from '../../../api/persons/dto/simple-customer.dto'
import useFeatureFlags from '../../../../hooks/useFeatureFlags'

// If HR Admin, get the Clients that are flagged as Census V2 enabled.
// Platform Admin can view view all clients through Census V2 regardless of flag
export function useCensusV2Clients() {
  const role = useSelector(authSelectors.getRole)
  const [clients, setClients] = useState<SimpleCustomerDto[]>([])
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState<Error | null>(null)
  const { flags } = useFeatureFlags()

  useEffect(() => {
    const fetchClients = async () => {
      try {
        const data = await clientsAllowedByCensusV2Flag({
          userRole: role as string,
          flags,
        })
        const sorted = data.sort((a, b) => a.name.localeCompare(b.name))
        setClients(sorted)
      } catch (err) {
        setError(err as Error)
      } finally {
        setIsLoading(false)
      }
    }

    fetchClients()
  }, [role, flags])

  return { clients, isLoading, error }
}
